export default "__VITE_ASSET__B5W6b0bH__"